// extracted by mini-css-extract-plugin
export default {"productDescription":"Gaa-z","featuredDescription":"Haa-z","description":"Iaa-z","more":"Jaa-z","descriptionSku":"Kaa-z"};